import { trackRouter } from 'vue-gtag-next';
import { getData } from '@streampac.io/chef_sp_1';
import { createRouter, createWebHistory } from 'vue-router';

import Home from '../views/Home';

const ActivateAccount = () => import( '../views/ActivateAccount');

const About = () => import( '../views/About');
// const VideoOverview = () => import( '../views/VideoOverview');
// const CategoryOverview = () => import( '../views/CategoryOverview');
const CategoryOverviewWithSidebar = () => import( '../views/CategoryOverviewWithSidebar');
const VideoSingle = () => import( '../views/VideoSingle');
const Account = () => import( '../views/Account');
// const WatchList = () => import( '../views/WatchList');

// const SubscriptionPage = () => import( '../views/SubscriptionPage');
// const RegisterPage = () => import( '../views/RegisterPage');
// const PaymentSucceeded = () => import( '../views/PaymentSucceeded');
// const PaymentFailed = () => import( '../views/PaymentFailed');
const PrivacyPolicy = () => import( '../views/PrivacyPolicy');
const TermsAndConditions = () => import( '../views/TermsAndConditions');
const ResetPasswordPage = () => import( '../views/ResetPasswordPage');

// const movieFestivalPage = () => import( '../views/AboutUs');
// const movieFestivalDetailPage = () => import( '../views/AboutUs');

const VideoOverview = () => import( '../views/VideoOverview');

const VideoCategoryPage = () => import( '../views/VideoCategoryPage');
const ProgrammePage = () => import( '../views/ProgrammePage');

const FaqPage = () => import( '../views/FaqPage');


// const Dashboard = () => import( '../views/Dashboard');

const Login = () => import( '../views/Login');

const SearchResultsPage = () => import( '../views/SearchResultsPage');

const NotFound = () => import( '../views/NotFound');

const routes = [
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: { pageName: 'Login' }
	},
	{
		path: '/accountinvitation/:activateAccountId',
		name: 'ActivateAccount',
		component: ActivateAccount,
		meta: { auth: false, pageName: 'Activate account' }
	},
    // {
	// 	path: '/activate-account/:activateAccountId',
	// 	name: 'ActivateAccount2',
	// 	component: ActivateAccount,
	// 	meta: { auth: false, pageName: 'Activate account' }
	// },
	{
		path: '/',
		name: 'Home',
		component: Home,
	},
	{
		path: '/about',
		name: 'About',
		component: About,
		meta: {
			auth: true, 
            pageName: 'Over ons'
		}
    },
	// },
	// {
	// 	path: '/films',
	// 	name: 'VideoOverview',
	// 	component: VideoOverview,
	// 	meta: {
	// 		auth: true,
	// 		pageName: 'Films'
	// 	}
	// },
	// {
	// 	path: '/films/:category',
	// 	name: 'CategoryOverview',
	// 	component: CategoryOverview,
	// 	props: true,
	// 	meta: {
	// 		auth: true,
	// 		breadcrumbs: [
	// 			{
	// 				name: 'Films',
	// 				slug: '/films'
	// 			}
	// 		]
	// 	}
	// },
    {
		path: '/videos',
		name: 'VideoOverview',
		component: VideoOverview,
		meta: {
			auth: true,
		}
		
	},
	{
		path: '/video/:slug',
		name: 'VideoDetails',
		component: VideoSingle,
		meta: {
			auth: true,
		}
		
	},
    {
		path: '/videos/:category',
		name: 'VideoCategoryPage',
		component: VideoCategoryPage,
		meta: {
			auth: true,
            breadcrumbs: [
				{
					name: 'Videos',
					slug: '/videos'
				}
			]
		}	
	},
    {
		path: '/programme/:category',
		name: 'programmePage',
		component: ProgrammePage,
		meta: {
			auth: true,
		}	
	},
	// {
	// 	path: '/filmfestival',
	// 	name: 'movieFestivalPage',
	// 	component: movieFestivalPage,
	// 	meta: { auth: true, pageName: 'Filmfestival' }
	// },
	// {
	// 	path: '/filmFestival/:category',
	// 	name: 'movieFestivalDetailPage',
	// 	component: movieFestivalDetailPage,
	// 	meta: {
	// 		auth: true,
	// 		breadcrumbs: [
	// 			{
	// 				name: 'filmfestival',
	// 				slug: '/filmfestival'
	// 			}
	// 		]
	// 	}
	// },
	{
		path: '/account',
		name: 'Account',
		component: Account,
		meta: { auth: true, pageName: 'Account' }
	},
	// {
	// 	path: '/account/mijn-lijst',
	// 	name: 'WatchList',
	// 	component: WatchList,
	// 	meta: { auth: true, pageName: 'Mijn lijst' }
	// },
	// {
	// 	path: '/registreren',
	// 	name: 'RegisterPage',
	// 	component: RegisterPage,
	// 	meta: { pageName: 'Registreren' }
	// },
	// {
	// 	path: '/abonneer-nu',
	// 	name: 'AbonneerNu',
	// 	component: SubscriptionPage,
	// 	meta: { auth: true, pageName: 'Abonneer nu' }
	// },
	// {
	// 	path: '/betaling-gelukt',
	// 	name: 'PaymentSucceeded',
	// 	component: PaymentSucceeded,
	// 	meta: { pageName: 'Betaling gelukt' }
	// },
	// {
	// 	path: '/betaling-mislukt',
	// 	name: 'PaymentFailed',
	// 	component: PaymentFailed,
	// 	meta: { pageName: 'Betaling mislukt' }
	// },
	{
		path: '/privacy-policy',
		name: 'PrivacyPolicy',
		component: PrivacyPolicy,
		meta: { pageName: 'Privacy policy' }
	},
    {
		path: '/faq',
		name: 'FaqPage',
		component: FaqPage,
		meta: { pageName: 'Faq' }
	},
	{
		path: '/terms-and-conditions',
		name: 'TermsAndConditions',
		component: TermsAndConditions,
		meta: { pageName: 'Terms and conditions' }
	},
	// {
	// 	path: '/reset-password/:passwordForgotId',
	// 	name: 'ResetPasswordPage1',
	// 	component: ResetPasswordPage
	// },
    {
		path: '/forgotpassword/:passwordForgotId',
		name: 'ResetPasswordPage',
		component: ResetPasswordPage
	},
	// {
	// 	path: '/dashboard',
	// 	name: 'Dashboard',
	// 	component: Dashboard,
	// 	meta: { auth: true, admin: true, pageName: 'Dashboard' }
	// },
	{
		path: '/films',
		name: 'CategoryOverviewWithSidebar',
		component: CategoryOverviewWithSidebar,
		meta: {  auth: true, pageName: 'Films' }
	},
	// {
	// 	path: '/filmklap-films/:graden',
	// 	name: 'CategoryOverviewWithSidebarGrades',
	// 	component: CategoryOverviewWithSidebar
	// },
	{
		path: '/search/:searchParam',
		name: 'search',
		component: SearchResultsPage,
		meta: {
			auth: true,
			pageName: 'Search',
			breadcrumbs: [
				{
					name: 'search',
					slug: '/search'
				}
			]
		}
	},
	{
		path: '/:notFound(.*)',
		component: NotFound,
		pageName: '404 - not found'
	}
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, _2, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else if (to.hash) {
            return {
                selector: to.hash
            }
        }

		

		return { left: 0, top: 0 };
	}
});

router.beforeEach((to, from, next) => {

	// const queryString = window.location.search;
	// const urlParams = new URLSearchParams(queryString);

	// if (urlParams && urlParams !== "") {
	// 	const gradenCat = urlParams.get("graden");
	// 	const themaCat = urlParams.get("thema");

	// 	if (gradenCat && gradenCat !== "") {
	// 		to.meta.graden = gradenCat;
	// 	}

	// 	if (themaCat && themaCat !== "") {
	// 		to.meta.thema = themaCat;
	// 	}
	// }

	if (to.matched.some(route => route.meta.auth)) {
		if (getData('loginData') === null) {
			console.log('no access-token');
			next({
				path: '/'
			});
		} else {
			next();
		}
	} else {
		next();
	}
});

// const DEFAULT_TITLE = 'Filmklap';

// router.afterEach(to => {
// 	// Use next tick to handle router history correctly
// 	// see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
// 	// setTimeout(() => {
// 	// 	if (to.meta.pageName && to.meta.pageName !== '') {
// 	// 		document.title = to.meta.pageName + ' - Filmklap';
// 	// 	} else {
// 	// 		document.title = DEFAULT_TITLE;
// 	// 	}
// 	// }, 300);
// });

trackRouter(router, { useScreenview: true });

export default router;
